import React, {MouseEvent, useContext, useEffect, useState} from "react";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {DateTime} from "luxon";
import css from '../calendarioPresenze_WF.module.css'
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda, selectSitePreferences, selectUser} from "@commons/core.slice";
import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {mm2HHmmFormat} from "@commons/utils/util";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import classNames from "classnames";
import {ComboButton} from "@components/ComboButton";
import PannelloGiornataPLUS from "./pannelloGiornataPLUS";
import {WeekCell} from "../comps/WeekCell";
import {DayCellDisclosure} from "../comps/DayCellDisclosure";
import PulsantieraCalendarioGestionePLUS from "./comps/PulsantieraCalendarioGestionePLUS";
import {RiepilogoTotaliPresenze} from "../comps/RiepilogoTotaliPresenze";
import {IconLockFilled, IconPlayerTrackNextFilled, IconPlayerTrackPrevFilled} from "@tabler/icons-react";
import BannerGM from "../comps/BannerGM";
import PanelGM from "../comps/PanelGM";
import {CalendarioChiusureRecord} from "@commons/mapping/CalendarioChiusureRecord";
import {PresenzeContext, UpdaterLavoratore} from "@commons/hooks/usePresenze";
import {Periodo} from "@commons/types";
import {GiustificazioneDiMassaTask} from "@commons/services/presenze_calcolo/sub_calcolo/GiustificazioneDiMassaTask";

const CopyToClipboard: React.FC<{ text: string, children?: React.ReactNode }> = ({text, children}) => {
    return <>{children}</>
}

export type TipoVista = 'lista' | 'calendario';
export type StatoGM = 'IN_PAUSA' | 'IN_SELEZIONE' | 'AVVIATA';

export const giorniSettimana = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

interface CalendarioProps {
    lavoratore: LavoratorePresenzeRecord,
    updLavoratore: (lav: (LavoratorePresenzeRecord | null), updFn?: UpdaterLavoratore) => void,
    prev: (() => void) | undefined,
    next: (() => void) | undefined,
    setDayModified: (day2Update: PresenzeGiornataPlusRecord, modified: boolean) => void,
    hasDaysToSave: (lavoratore: LavoratorePresenzeRecord) => boolean,
    stampaPeriodo: () => void,
    calcolaPeriodo: () => void,
    applicaGM: (daysForGM: PresenzeGiornataPlusRecord[], payload: GiustificazioneDiMassaTask) => void,
    salvaPeriodo: () => void,
    ripristinaPeriodo: () => void,
}

export const CalendarioGestionePLUS: React.FC<CalendarioProps> = ({
                                                                      lavoratore,
                                                                      updLavoratore,
                                                                      prev,
                                                                      next,
                                                                      setDayModified,
                                                                      hasDaysToSave,
                                                                      stampaPeriodo,
                                                                      calcolaPeriodo,
                                                                      applicaGM,
                                                                      salvaPeriodo,
                                                                      ripristinaPeriodo,
                                                                  }) => {
    const presenzeOpts = useAppSelector(selectSitePreferences).presenzeOptions;

    const [currentWeek, setNextCurrentWeek] = useState<number | null>(null);
    const [elencoGiuEvidenza, setNextElencoGiuEvidenza] = useState<string[]>([]);
    const [daysForGM, setDaysForGM] = useState<PresenzeGiornataPlusRecord[]>([])

    const [vista, setVista] = useState<TipoVista>((presenzeOpts && presenzeOpts.dayView) ? presenzeOpts.dayView : 'calendario');
    const toggleVista = () => setVista(current => ((current === 'lista') ? 'calendario' : 'lista'));

    const [statoGM, setStatoGM] = useState<StatoGM>('IN_PAUSA');
    const isGMAvviata = statoGM !== 'IN_PAUSA';

    useEffect(() => {
        if (isGMAvviata && currentWeek)
            setNextCurrentWeek(null);
    }, [isGMAvviata, currentWeek]);

    const Pulsantiera = () => <PulsantieraCalendarioGestionePLUS onClickEye={() => toggleVista()}
                                                                 statoGM={statoGM}
                                                                 setStatoGM={setStatoGM}
                                                                 daysForGM={daysForGM}
                                                                 setDaysForGM={setDaysForGM}
                                                                 hasDaysToSave={hasDaysToSave(lavoratore)}
                                                                 stampaPeriodo={stampaPeriodo}
                                                                 calcolaPeriodo={calcolaPeriodo}
                                                                 salvaPeriodo={salvaPeriodo}
                                                                 ripristinaPeriodo={ripristinaPeriodo}/>;
    return (<>
        {/* L'HEADER DEL CALENDARIO E' STATA SPOSTATA ALL'ESTERNO DEL CALENDARIO, PER FAR FUNZIONARE LO "STICKY"!!! */}
        <div className={`sticky top-[64px] ${css.header}`}>{/* top-[64px] --> altezza della navbar, dov'è posizionato il menù utente */}
            {/*INTESTAZIONE CALENDARIO*/}
            <HeaderCalendario lavoratore={lavoratore} prevLavoratore={prev} nextLavoratore={next}></HeaderCalendario>

            <div className={classNames(css.headerCalendario, 'flex-col space-y-2')}>
                {/*SECONDA RIGA DEI BTNS!!*/}
                <Pulsantiera/>
                {/* BANNER - DATAIL PER UTILIZZO DELLA GIUSTIFICAZIONE DI MASSA */}
                {isGMAvviata && <BannerGM/>}
            </div>
        </div>
        <div className={`${css.containerCalendario}`}>


            {/*CALENDARIO MENSILE*/}
            <BodyCalendario lavoratore={lavoratore}
                            updLavoratore={updLavoratore}
                            vista={vista}
                            currentWeek={currentWeek}
                            setNextCurrentWeek={setNextCurrentWeek}
                            setDayModified={setDayModified}
                            daysForGM={daysForGM}
                            setDaysForGM={setDaysForGM}
                            statoGM={statoGM}
                            setStatoGM={setStatoGM}
                            applicaGM={(payload) => {
                                applicaGM(daysForGM, payload);
                                setDaysForGM([]);
                            }}
                            elencoGiuEvidenza={elencoGiuEvidenza}
                            setNextElencoGiuEvidenza={setNextElencoGiuEvidenza}
            ></BodyCalendario>

            <div className={classNames(css.headerCalendario, 'flex-col space-y-2')}>
                <Pulsantiera/>
            </div>

            <FooterCalendario lavoratore={lavoratore} elencoGiuEvidenza={elencoGiuEvidenza} setNextElencoGiuEvidenza={setNextElencoGiuEvidenza}/>
        </div>
    </>)
}

const HeaderCalendario: React.FC<{
    lavoratore: LavoratorePresenzeRecord,
    prevLavoratore: (() => void) | undefined,
    nextLavoratore: (() => void) | undefined,
}> = ({lavoratore, prevLavoratore, nextLavoratore}) => {
    const user: UserCRUDRecord | null = useAppSelector(selectUser); // User corrente
    const selectedAz = useAppSelector(selectAzienda);
    const {periodo, calendarioChiusure,} = useContext(PresenzeContext);
    const dataChiusura: DateTime | null = calendarioChiusure ? CalendarioChiusureRecord.getScadenza(calendarioChiusure, periodo.mese) : null;
    const isPeriodoChiuso = selectedAz && user ? GestionePlus.statoPeriodo(selectedAz, periodo, lavoratore?.days || null, null, user).chiuso : true;
    const formattedPeriodo = Periodo.getDate(periodo, {locale: 'it'}).toFormat('LLLL yyyy');

    return <div className={classNames(css.headerCalendario, 'flex-row')}>
        {/* INDICAZIONE MESE */}
        <div className="flex flex-col w-fit">
            <div className={classNames(css.periodo, 'sm:mr-auto')}>
                <span className="capitalize whitespace-nowrap">{formattedPeriodo}</span>
                {isPeriodoChiuso && <>&nbsp;<IconLockFilled className="rounded bg-white text-[#235f6a] w-5 p-0.5"/></>}
            </div>
            {(!isPeriodoChiuso && dataChiusura) && <span className="text-xs">editabile fino al {dataChiusura.toFormat('dd/LL/yyyy')}</span>}
        </div>

        {/* NOMINATIVO */}
        <div className="flex flex-col text-center w-fit mx-auto">
            <span className="text-base sm:text-lg lg:text-xl 2xl:text-2xl">{lavoratore?.cognome}&nbsp;{lavoratore?.nome}</span>
            <p className="text-xs text-center select-text">
                <CopyToClipboard text={`select *
                                        from presenze_giornata
                                        where id_dip = ${lavoratore.id}
                                          and anno = ${periodo.anno}
                                          and mese = ${periodo.mese}`}>
                    <span>#{lavoratore.id}</span>
                </CopyToClipboard>
            </p>
        </div>

        {/*TASTI PREC. / SUCC.*/}
        <div className="inline-flex w-fit">
                    <span className="ml-auto">
                        <ComboButton btnClass="p-2 sm:px-3" onClick={prevLavoratore} Icon={IconPlayerTrackPrevFilled}/>
                    </span>
            <span className="mr-auto sm:mr-0">
                        <ComboButton btnClass="p-2 sm:px-3" onClick={nextLavoratore} Icon={IconPlayerTrackNextFilled}/>
                    </span>
        </div>
    </div>
}

const BodyCalendario: React.FC<{
    lavoratore: LavoratorePresenzeRecord,
    updLavoratore: (lav: (LavoratorePresenzeRecord | null), updFn?: UpdaterLavoratore) => void,
    currentWeek: number | null,
    setNextCurrentWeek: React.Dispatch<React.SetStateAction<number | null>>,
    setDayModified: (day2Update: PresenzeGiornataPlusRecord, modified: boolean) => void,
    vista: TipoVista,
    daysForGM: PresenzeGiornataPlusRecord[],
    setDaysForGM: React.Dispatch<React.SetStateAction<PresenzeGiornataPlusRecord[]>>,
    statoGM: StatoGM,
    setStatoGM: React.Dispatch<React.SetStateAction<StatoGM>>,
    applicaGM: (payload: GiustificazioneDiMassaTask) => void,
    elencoGiuEvidenza: string[],
    setNextElencoGiuEvidenza: React.Dispatch<React.SetStateAction<string[]>>,
}> = ({
          lavoratore, updLavoratore, setDayModified, vista, setNextCurrentWeek, daysForGM, statoGM, currentWeek,
          setStatoGM, setDaysForGM,
          elencoGiuEvidenza, setNextElencoGiuEvidenza,
          applicaGM,
      }) => {
    const {listaGiustificativi, listaTurni, listaTerminali, periodo, calendarioChiusure, currentDay, selectGiornata} = useContext(PresenzeContext);
    const [dtPerno, setNextDtPerno] = useState<DateTime | null>(null);
    const isGMAvviata = statoGM !== 'IN_PAUSA';

    const closePopup = () => {
        selectGiornata(null);
    }

    const isVistaCalendario = vista === 'calendario';

    //console.log(days4GM)
    useEffect(() => {
        if (daysForGM.length === 1)
            setNextDtPerno(DateTime.fromISO(daysForGM[0].dtGiornata!));
    }, [daysForGM]);
    useEffect(() => {
        if (statoGM === 'IN_PAUSA')
            setNextDtPerno(null);
    }, [statoGM]);

    const handleMouseClick = ((event: MouseEvent, day: PresenzeGiornataPlusRecord) => {
        event.stopPropagation();

        if (day && day.dtGiornata && event.type === 'click') {
            const dtGiornata = DateTime.fromISO(day.dtGiornata);
            if (!event.ctrlKey && !event.shiftKey) {
                console.log('CLICK rilevato!');
                setDaysForGM([day])
            }

            if (!event.ctrlKey && event.shiftKey) {
                console.log('Shift+Click rilevato!');
                if (dtPerno) {
                    const daysToAdd: PresenzeGiornataPlusRecord[] = []
                    for (const d of lavoratore.days!) {
                        if (d.dtGiornata) {
                            const dtGiornataPresenze = DateTime.fromISO(d.dtGiornata);
                            if (dtGiornata < dtPerno) {
                                if (dtGiornataPresenze >= dtGiornata && dtGiornataPresenze <= dtPerno)
                                    daysToAdd.push(d);
                            } else if (dtGiornata > dtPerno) {
                                if (dtGiornataPresenze <= dtGiornata && dtGiornataPresenze >= dtPerno)
                                    daysToAdd.push(d);
                            }
                        }
                    }
                    setDaysForGM(daysToAdd)
                } else {
                    setDaysForGM([day]);
                }
            }

            if (!event.shiftKey && event.ctrlKey) {
                console.log('Ctrl+Click rilevato!');
                if (daysForGM.find(d => d.dtGiornata === day.dtGiornata))
                    setDaysForGM(daysForGM.filter(d => d.dtGiornata !== day.dtGiornata));
                else
                    setDaysForGM([...daysForGM, day]);
            }
        }
    });

    return <div className={`${css.textColorCalendario} p-0.5 text-xs ${css.calendarioGPLUSScollbar}`}>

        {isVistaCalendario &&
            // <div className="flex flex-row w-auto gap-x-0.5 mb-0.5">
            <div className="grid grid-cols-[repeat(8,minmax(75px,_1fr))] gap-x-0.5 mb-0.5">
                {/*<div className={`${css.weekColor} border border-[#63cde1] rounded-md w-[12.5%] py-0.5`}> /!* w-[12.5%] --> per allineare gli elementi ai giorni sottostanti *!/*/}
                <div className={`${css.weekColor} border border-[#63cde1] rounded-md py-0.5`}>
                    <div className="w-fit mx-auto font-semibold">Week</div>
                </div>

                {giorniSettimana.map((item, index) => (
                    // <div className="bg-[#5e6c80] border border-[#5D6180] rounded-md w-[12.5%] py-0.5 text-white" key={index}>
                    <div className="bg-[#5e6c80] border border-[#5D6180] rounded-md py-0.5 text-white" key={index}>
                        <div className="w-fit mx-auto font-semibold">{item}</div>
                    </div>))}
            </div>}

        {lavoratore.weeks?.map((week, weekIndex) => {
            const weekOpen = !isGMAvviata ? (week.numWeekKey === currentWeek) : undefined;
            const lastDayWeek = daysForGM.length && daysForGM.slice(-1)[0].numSettimana;

            return (<div key={weekIndex}>
                {/*<div className={`flex flex-row w-full space-x-0.5 ${isVistaCalendario ? 'h-[84px]' : ''}`}>*/}
                <div className={isVistaCalendario ? 'grid grid-cols-[repeat(8,minmax(75px,_1fr))] gap-x-0.5 mb-0.5' : 'flex flex-row w-full space-x-0.5'}>
                    {/* SETTIMANA */}
                    <WeekCell page="Presenze" week={week} lavoratore={lavoratore} weekOpen={weekOpen} setNextCurrentWeek={setNextCurrentWeek} isGMAvviata={isGMAvviata}/>

                    {/* GIORNI */}
                    {/*<div className={classNames(isVistaCalendario ? 'flex flex-row space-x-0.5' : 'space-y-0.5', 'mb-0.5 w-full')}>*/}
                    <div className={classNames(isVistaCalendario ? 'grid grid-cols-subgrid col-span-7' : 'flex flex-col space-y-0.5 mb-0.5 w-full')}>
                        {/* Horizontal lines - giorni settimana */}
                        {
                            lavoratore.days && [0, 1, 2, 3, 4, 5, 6].map(dayIndex => {
                                const day = lavoratore.days![dayIndex + (weekIndex * 7)];
                                let hhPreviste = '??,??';
                                let descrizioneTurno = '????';

                                if (day) {
                                    const previstoInMinuti = RiepilogoOrePlus.getTotaleHPrev(day.totali);
                                    hhPreviste = mm2HHmmFormat(previstoInMinuti);
                                    const turno = listaTurni.find(turno => turno.codTurno === day.codTurno);
                                    descrizioneTurno = turno ? turno.distribuzione[day.idGiorno - 1].descrizione : '';
                                }

                                return <div key={dayIndex + (weekIndex * 7)} className={isVistaCalendario ? 'w-full' : ''}>
                                    <DayCellDisclosure page="Presenze"
                                                       vista={vista}
                                                       periodo={periodo}
                                                       lavoratore={lavoratore}
                                                       day={day}
                                                       hhPreviste={hhPreviste}
                                                       descrizioneTurno={descrizioneTurno}

                                                       isGMAvviata={isGMAvviata}
                                                       days4GM={daysForGM}
                                                       handleMouseClick={handleMouseClick}
                                                       elencoGiuEvidenza={elencoGiuEvidenza}
                                                       listaGiustificativi={listaGiustificativi}
                                                       listaTerminali={listaTerminali}>
                                        {/* MODAL PER GESTIRE LA GIORNATA - si apre solo se avviaGM===false */}
                                        <PannelloGiornataPLUS lavoratore={lavoratore}
                                                              updLavoratore={updLavoratore}
                                                              dtGiornata={day.dtGiornata}
                                                              onCancelEdit={closePopup}/>
                                    </DayCellDisclosure>
                                </div>
                            })
                        }
                    </div>
                </div>

                {/* PANNELLO PER LA GIUSTIFICAIZONE DI MASSA
                  * Si apre solo se ci sono 2 o + giorni selezionati ed è stato premuto "Applica GM"
                  */}
                {(statoGM === 'AVVIATA' && daysForGM.length >= 2 && (lastDayWeek === week.numWeekKey)) &&
                    <PanelGM lavoratore={lavoratore} setStatoGM={setStatoGM} setDaysForGM={setDaysForGM} applicaGM={applicaGM}/>}

                {/* PANNELLO RIEPILOGHI SETTIMANALE */}
                {(weekOpen) && <RiepilogoTotaliPresenze lavoratore={lavoratore} week={week} setNextCurrentWeek={setNextCurrentWeek}
                                                        elencoGiuEvidenza={elencoGiuEvidenza}
                                                        setNextElencoGiuEvidenza={setNextElencoGiuEvidenza}/>}
            </div>)
        })}
    </div>
}

const FooterCalendario: React.FC<{
    lavoratore: LavoratorePresenzeRecord,
    elencoGiuEvidenza: string[],
    setNextElencoGiuEvidenza: React.Dispatch<React.SetStateAction<string[]>>,
}> = ({lavoratore, elencoGiuEvidenza, setNextElencoGiuEvidenza}) => {

    // FOOTER CALENDARIO PER RIEPILOGHI
    return <div className={css.footerCalendario}>
        <RiepilogoTotaliPresenze lavoratore={lavoratore}
                                 elencoGiuEvidenza={elencoGiuEvidenza}
                                 setNextElencoGiuEvidenza={setNextElencoGiuEvidenza}
        />
    </div>
}